import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function ThinTickCircle(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 20"
  }, props), React.createElement("ellipse", {
    cx: 9.304,
    cy: 10,
    rx: 9.207,
    ry: 10
  }), React.createElement("path", {
    stroke: "#fff",
    d: "M3.559 9.863L7.854 13.9l8.305-7.807"
  }));
}

export { ThinTickCircle };
//# sourceMappingURL=ThinTickCircle.js.map